import { Trophy } from 'lucide-react'
import BracketEntryCard from './BracketEntryCard'

export default function TournamentBracketsTab({ brackets, userEntries, viewerIsOwner = true }) {
  // DUB-174: on another player's profile only show brackets they actually
  // entered (no empty "needs picks" cards for the viewer), and keep their
  // picks gated until the bracket locks.
  const visibleBrackets = viewerIsOwner
    ? brackets
    : brackets.filter(b => !!userEntries[b.id])

  if (visibleBrackets.length === 0) {
    return (
      <div className="text-center py-12">
        <Trophy className="h-12 w-12 text-muted-foreground mx-auto mb-4 opacity-50" />
        <p className="text-lg text-muted-foreground mb-1">No brackets available yet</p>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {visibleBrackets.map((bracket, index) => {
        const userEntry = userEntries[bracket.id]
        const hasEntry = !!userEntry
        const canMakePicks = bracket.status === 'open'
        const needsPicks = viewerIsOwner && canMakePicks && !hasEntry
        const canViewPicks = viewerIsOwner || (bracket.rounds?.length
          ? bracket.rounds.some(r => r.status === 'locked' || r.status === 'complete')
          : ['locked', 'complete'].includes(bracket.status))

        return (
          <BracketEntryCard
            key={bracket.id}
            bracketId={bracket.id}
            entryId={hasEntry ? userEntry.entryId : null}
            divisionName={bracket.name}
            bracketStatus={bracket.status}
            canViewPicks={canViewPicks}
            metadata={hasEntry ? {
              total_points: userEntry.totalScore,
              potential_points: userEntry.potentialPoints,
              accuracy: userEntry.accuracy,
              champion_status: userEntry.championStatus,
              champion_team_name: userEntry.championName
            } : null}
            variant={needsPicks ? 'needsPicks' : 'default'}
            blurVariant={index % 6}
          />
        )
      })}
    </div>
  )
}
